import { useEffect } from "react";

/**
 * mount/unmount helper for external sync (focus, subscriptions, one-shot fetches).
 * app code should not call useEffect directly — use this instead.
 */
export function useMountEffect(effect: () => void | (() => void)) {
  /* eslint-disable react-hooks/exhaustive-deps -- mount-only boundary */
  useEffect(effect, []);
  /* eslint-enable react-hooks/exhaustive-deps */
}
